<template>
  <div>
    <Toplist title='Top 100 BIGCOMMERCE stores 2024' url='top-100-bigcommerce-stores-data.json'></Toplist>
  </div>
</template>

<script>
import Toplist from './common/toplist.vue'
export default {
  name: "online",
  components:{
    Toplist
  },
};
</script>



// WEBPACK FOOTER //
// src/components/bigcommerce.vue